// userService.js
import apiClient from "./apiClient";

export const getUserOffices = () => apiClient.get("/user-offices");
export const getUserOfficesById = (id) => apiClient.get(`/user-offices/${id}`);
export const createUserOffice = (data) => apiClient.post("/user-offices", data);
export const updateUserOffice = (id, data) => apiClient.put(`/user-offices/${id}`, data);
export const deleteUserOffice = (id) => apiClient.delete(`/user-offices/${id}`);